import React from 'react';
import Footer from '#/components/layout/Footer';
import NavBar from '#/components/layout/NavBar';
import './PageWrapper.style.scss';
import { Outlet } from 'react-router-dom';

const PageWrapper = () => {
  return (
    <div className="pageWrapper">
      <NavBar />

      <div className="pageWrapper--content">
        <div>
          <Outlet />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default React.memo(PageWrapper);
